<template lang="pug">
  RollInfoPanel
    .assign-metadata
      .row
        .col-sm-12
          .form-group
            label Select schema
            .input
              select.form-control(v-model="selectedSchemaId")
                option(v-for="schema in schemas" :value="schema.id") {{schema.name}}

          .form-group(v-if="selectedSchemaId")
            label Metadata
            .loading(v-if="schemaLoading") Loading...
            .metadata-editor-wrap(v-else)
              MetadataEditor(:schema="schema" :metadata="metadata" :disabled="saving" @update:data="updateMetadata")

      .row
        .col-xs-12.text-right
          button.btn.btn-primary(@click="validateAndNext()" :disabled="!selectedSchemaId || !isValid") Continue

</template>
<script>
import MetadataEditor from '@/components/metadataeditor/MetadataEditor'
import activationSession from '../service/ActivationSession'
import RollInfoPanel from '../components/RollInfoPanel'

export default {
  data: () => ({
    schemaLoading: false,
    selectedSchemaId: null,
    schema: {},
    metadata: {},
    isValid: true,
    saving: false,
    schemas: []
  }),
  created() {
    activationSession
      .getMetadataSchemas()
      .then((resp) => {
        this.schemas = resp.data.schema
        this.schemas
          .filter((it) => it.isDefault)
          .forEach((it) => {
            this.selectedSchemaId = it.id
          })
      })
      .catch((e) => { this.$emit('error', e) })
  },
  mounted() {
    const shd = activationSession.getSchemaAndData() || {}
    if (shd.schemaId) {
      this.selectedSchemaId = shd.schemaId
    }
    if (shd.metadata) {
      this.metadata = shd.metadata
    }
  },
  watch: {
    selectedSchemaId() {
      if (this.selectedSchemaId) {
        this.schemaLoading = true
        activationSession
          .getSchemaById(this.selectedSchemaId)
          .then((resp) => {
            this.schema = resp.data
            this.schemaLoading = false
          })
          .catch((e) => {
            this.schemaLoading = false
            this.$emit('error', e)
          })
      }
    }
  },
  methods: {
    updateMetadata(metadata, isValid) {
      this.metadata = { ...this.metadata, ...metadata }
      this.isValid = isValid
    },
    validateAndNext() {
      this.saving = true
      if (!this.isValid) {
        this.metadataEditorError = 'Editor contains invalid values. Please fix them and try again.'
        this.saving = false
        return
      }
      activationSession.setSchemaAndData({
        schemaId: this.selectedSchemaId,
        metadata: this.metadata
      })
      this.saving = false
      this.$emit('next')
    }
  },
  components: {
    RollInfoPanel,
    MetadataEditor
  }
}
</script>

<style lang="scss">
  .metadata-editor-wrap {
    border: solid #dedede 1px;
    border-radius: 3px;
    padding: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/pages/activator/wiz/AssignMetadata.vue